import { render, staticRenderFns } from "./FCInfoForm.vue?vue&type=template&id=730e5046&scoped=true&"
import script from "./FCInfoForm.vue?vue&type=script&lang=js&"
export * from "./FCInfoForm.vue?vue&type=script&lang=js&"
import style0 from "./FCInfoForm.vue?vue&type=style&index=0&id=730e5046&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730e5046",
  null
  
)

export default component.exports